
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    profileData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup() {
    const router = useRouter();

    const goHome = () => {
      router.push({ name: "Home" });
    };

    const logout = () => {
      localStorage.clear();
      router.push({ name: "Login" });
    };

    return {
      goHome,
      logout,
    };
  },
});
